import { TranslateService } from '@ngx-translate/core';
import { serialize } from 'class-transformer';
import { ViewState, ViewStateField, ViewStateGroup, ViewStateSort } from '../model/view-state';
import { SortBy } from '../model/data-source';

function createViewState(sortBy: SortBy[], visibleColumnNames: string[], groupBy?: string, additional?: Record<string, any>): ViewState {
  let viewStateSort: ViewStateSort = null;
  if (sortBy) {
    viewStateSort = new ViewStateSort(sortBy);
  }
  let viewStateGroup: ViewStateGroup[] = null;
  if (groupBy)
    viewStateGroup = [new ViewStateGroup(groupBy)];
  const viewFields = visibleColumnNames.map(column => new ViewStateField(column));

  return new ViewState(viewFields, viewStateSort, viewStateGroup, additional);
}

export function createViewStateAsString(sortBy: SortBy[], visibleColumnNames: string[], groupBy?: string, additional?: Record<string, any>): string {
  return `(${serialize(createViewState(sortBy, visibleColumnNames, groupBy, additional))})`;
}

export function createTitlesAsString(visibleColumnNames: string[], translate: TranslateService): string {
  const titles = visibleColumnNames.reduce((object, column) => (object[column] = translate.instant(column), object), {});
  return serialize(titles);
}
